import {
  buildRobloxTopChartsDownloadApiParams,
} from '@intelligence/v3/pages/RobloxTopCharts/utils/buildRobloxTopChartsDownloadParams';
import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { getFileNameCommon } from '@intelligence/components/DownloadCommon/DownloadPage/utils';

export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    downloadMode: 'commonConf',
    downloadConfigKey: 'robloxTopCharts',
    downloadFetchApi: '/api/v1/intelligence_pc/game/roblox/topcharts/metrics',
    downloadApiParams: buildRobloxTopChartsDownloadApiParams(params),
    isUsingNewMethod: false,
    fetchOnlyOnce: true,
    dataKey: undefined,
    $$fileName: getFileNameCommon(params),
    regionOptions: params?.regionOptions,
  };
};
